<template>
  <v-card class="dialog">
    <v-card-title class="primary">
      <span class="headline"> IMPORTAR PLANILHA</span>
    </v-card-title>
    <v-card-text class="py-5 px-4">
      <div grid-list-md>
        <v-layout wrap>
          <v-flex align-center d-flex xs12 sm6 md3>
            <a flat @click="salvarPlanilhaModelo">
              Baixar Modelo de Excel
            </a>
          </v-flex>

          <v-flex xs12 sm6 md2>
            <label
              for="file-upload-itens"
              :class="['button-custom', { disabled: loading }]"
            >
              ARQUIVO
            </label>
            <input
              @change="processarArquivo($event)"
              id="file-upload-itens"
              type="file"
              :disabled="loading"
            />
          </v-flex>
          <v-flex xs12 md7 class="pl-4">
            <input type="text" class="name-arquivo" v-model="arquivo.name" />
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </div>
    </v-card-text>
    <v-card-actions class="px-5 pb-5">
      <div v-if="!arquivoValido">
        <p class="text-error">
          {{ erro === undefined || null ? "Não foi possível importar o documento." : erro }}
        </p>
        <br />
        <small class="text-error">
          {{
            arquivoFaltante.length
              ? `${arquivoFaltante.length === 1 ? "A coluna" : "As colunas"} "${arquivoFaltante.join('", "')}" ${
                  arquivoFaltante.length === 1
                    ? "não foi encontrada"
                    : "não foram encontradas"
                }`
              : "Arquivo inválido"
          }}
        </small>
      </div>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="cancelar">CANCELAR</v-btn>
      <v-btn
        :disabled="loading"
        class="button-custom"
        flat
        @click="submeterArquivo(false)"
        v-if="!mostrarBotaoImportarComErros"
        >IMPORTAR</v-btn
      >
      <v-btn
        :disabled="loading"
        class="button-custom error"
        flat
        color="error"
        @click="submeterArquivo(true)"
        v-else
        style="color: white!important;"
        >IMPORTAR COM ERROS</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import { saveAs } from "file-saver";
import usuarioHelper from "@/helpers/usuario-logado.js";
import planilhaItens from "@/helpers/planilha-itens.js";

export default {
  name: "ModalImportarPlanilhaItens",

  data() {
    return {
      arquivo: {},
      arquivoValido: true,
      arquivoFaltante: [],
      conteudoPlanilha: null,
      erroPlanilha: null,
      erro: null,
      loading: false,
      mostrarBotaoImportarComErros: false,
      mensagemChassiConstaApoliceVigente:
        "O(s) chassi(s) já constam em uma apólice vigente:",
      mensagemChassiPossuiReservaMercado:
        "O(s) chassi(s) já possuem uma reserva de mercado:"
    };
  },

  methods: {
    processarArquivo(event) {
      this.arquivo = event.target.files[0] || {};
    },

    salvarPlanilhaModelo() {
      this.$store.commit("startLoading");
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/downloadPlanilhaModelo`, {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"]
          });
          saveAs(blob, "PlanilhaModelo.xlsx");
        })
        .catch(() => {})
        .finally(() => {
          this.$store.commit("endLoading");
        });
    },

    submeterArquivo(enviarComErros) {
      this.loading = true;
      const formData = new FormData();
      formData.append("planilha", this.arquivo);
      formData.append("ignorarErros", enviarComErros);
      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/validarPlanilha`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response.data) {
            if (response.data.erroMensagemReservaMercado) {
              this.arquivoValido = false;
              this.erro = response.data.erroMensagemReservaMercado;
              this.mostrarBotaoImportarComErros = true;
            } else {
              this.arquivoValido =
                typeof response.data.valido === "boolean"
                  ? response.data.valido
                  : true;
              this.arquivoFaltante =
                response.data.naoEncontrados instanceof Array
                  ? response.data.naoEncontrados
                  : [];
              this.conteudoPlanilha =
                response.data.conteudo instanceof Array
                  ? response.data.conteudo
                  : [];
              this.erroPlanilha =
                response.data.erros instanceof Array ? response.data.erros : [];
            }
            if (this.arquivoValido) {
              this.emitirConteudo();
            }
          }
        })
        .catch(error => {
          this.arquivoValido = false;
          this.erro =
            error.response && error.response.data
              ? error.response.data.message
              : null;
          this.mostrarModalImportarComErros(this.erro);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    mostrarModalImportarComErros(mensagemErro) {
      if (!mensagemErro) {
        return;
      }
      if (
        mensagemErro
          .toLowerCase()
          .includes(this.mensagemChassiConstaApoliceVigente.toLowerCase()) ||
        mensagemErro
          .toLowerCase()
          .includes(this.mensagemChassiPossuiReservaMercado.toLowerCase())
      ) {
        this.mostrarBotaoImportarComErros = true;
      }
    },

    emitirConteudo() {
      if (!(this.conteudoPlanilha instanceof Array)) {
        return;
      }
      const erros = this.erroPlanilha instanceof Array ? this.erroPlanilha : [];
      this.$emit("importar", {
        conteudoPlanilha: planilhaItens.mesclarErrosNosItens(
          this.conteudoPlanilha,
          erros
        ),
        erroPlanilha: erros
      });
    },

    cancelar() {
      this.$emit("cancelar");
    }
  }
};
</script>

<style>
.text-error {
  color: #f45353;
  font-weight: bold;
}

.name-arquivo {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 2px;
}

input[type="file"] {
  display: none;
}

.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;
  font-weight: bold;
}

.button-custom.error {
  max-width: 180px;
  color: white;
}

.button-custom:hover {
  background-color: #063f57;
}

.disabled,
.v-btn.button-custom:disabled {
  cursor: default;
  background-color: #063f57;
  color: #aaaaaa !important;
}

.disabled:hover {
  background-color: #063f57;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalImportarPlanilhaItens.vue